<template>
	<div>

		<template v-if="headerShow">
			<div class="sqzxOne">
				<div class="sqzxOneFor" v-for="(item,index) in itema.child" :key="index" @click="goClickOne(index)">
					<div class="sqzxOneForImg">
						<img :src="item.icon" />
					</div>
					<div class="sqzxOneForName">
						{{item.title}}
					</div>
					<div class="sqzxOneForCen">
						{{item.desc}}
					</div>
					<div class="sqzxOneForXian" v-if="index!==hzzxOne.length-1">
						<div></div>
					</div>
				</div>
			</div>
			<div class="gjfw">
				<div class="gjfwTil">{{$t('i18n_46')}}</div>
				<div class="gjfwDdian">
					<div class="gjfwDdianLeft">
						<div class="gjfwDdianLeftOne">{{allInfo.title}}</div>
						<div class="gjfwDdianLeftTwo">{{allInfo.company}}</div>
						<div class="gjfwDdianLeftThree">{{$t('i18n_47')}}：{{allInfo.address}}</div>
						<div class="gjfwDdianLeftFour">{{$t('i18n_48')}}：{{allInfo.phone}}</div>
					</div>
					<div class="gjfwDdianRight">
						<img src="@/assets/contact/sqzx/dd.png" />
					</div>
				</div>
			</div>

		</template>
		<template v-else>
			<div class="sqzxOne">
				<div class="sqzxOneFor"  :class="itema.child.length-1 !== index?'sqzxOneForBottom' : ''" v-for="(item,index) in itema.child" :key="index" @click="goClickOne(index)">
					<div class="sqzxOneForImg">
						<img :src="item.icon" />
					</div>
					<div class="sqzxOneForName">
						{{item.title}}
					</div>
					<div class="sqzxOneForCen">
						{{item.desc}}
					</div>
					<div class="sqzxOneForXian" v-if="index!==hzzxOne.length-1">
						<div></div>
					</div>
				</div>
			</div>
			<div class="gjfw">
				<div class="gjfwTil">{{$t('i18n_46')}}</div>
				<div class="gjfwDdian">
					<div class="gjfwDdianLeft">
						<div class="gjfwDdianLeftOne">{{allInfo.title}}</div>
						<div class="gjfwDdianLeftTwo">{{allInfo.company}}</div>
						<div class="gjfwDdianLeftThree">{{$t('i18n_47')}}：{{allInfo.address}}</div>
						<div class="gjfwDdianLeftFour">{{$t('i18n_48')}}：{{allInfo.phone}}</div>
					</div>
					<div class="gjfwDdianRight">
						<img src="@/assets/contact/sqzx/dd.png" />
					</div>
				</div>
			</div>
		</template>

	</div>
</template>

<script>
	import {
		get_headquarters
	} from '@/api/contact.js'
	export default {
		components: {

		},
		props: {
			itema: {
				typeof: Object,
				default: {}
			}
		},
		data() {
			return {
				hzzxOne: [{
						img: require("@/assets/contact/hzzx/pphz.png"),
						name: this.$t('i18n_49'),
						cen: 'brand@aohua.com'
					},
					{
						img: require("@/assets/contact/hzzx/sc.png"),
						name: this.$t('i18n_50'),
						cen: 'marketing@aohua.com'
					},
				],
				allInfo: ''
			}
		},
		mounted() {
			this.getAllgs();
		},
		methods: {
			getAllgs() {
				let data = {}
				get_headquarters(data).then(res => {
					console.log(res, "总部")
					this.allInfo = res.data.info
				}).catch(err => {
					console.log(err)
				})
			}
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.sqzxOne {
		width: 1200px;
		margin: 0 auto;
		background: #fafafa;
		display: flex;
		justify-content: center;
		height: 400px;
		// .sqzxOneFor:first-child{
		// 	border-right: 2px solid #AFAFAF;
		// }
		position: relative;



		.sqzxOneFor {
			width: 600px;
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;
			position: relative;
			z-index: 2;

			.sqzxOneForXian {
				position: absolute;
				top: 0;
				right: 0;
				z-index: 1;
				height: 100%;
				display: flex;
				align-items: center;

				>div {
					width: 2px;
					height: 200px;
					background: #AFAFAF;
				}
			}

			.sqzxOneForImg {
				img {
					width: 120px;
					height: 120px;
				}
			}

			.sqzxOneForName {
				font-size: 35px;
				font-family: Source Han Sans CN;
				font-weight: 500;
				color: #000000;
				margin-top: 30px;
			}

			.sqzxOneForCen {
				margin-top: 16px;
				font-size: 23px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #000000;
			}
		}
	}

	.gjfw {
		width: 1200px;
		margin: 0 auto;
		margin-top: 117px;
		padding-bottom: 95px;

		.gjfwTil {
			font-size: 36px;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #000000;
			margin-bottom: 96px;
		}

		.gjfwDdian {
			display: flex;
			align-items: center;
			width: 1200px;
			height: 400px;
			background: #fafafa;
			padding: 48px 128px;
			box-sizing: border-box;

			.gjfwDdianLeft {
				flex: 1;
				width: 0;
				height: 100%;
				display: flex;
				flex-direction: column;

				.gjfwDdianLeftOne {
					// font-size: 36px;
					font-size: 30px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #6A6A6A;
					flex: 1;
				}

				.gjfwDdianLeftTwo {
					font-size: 24px;
					font-family: Source Han Sans CN;
					font-weight: 500;
					color: #000000;
					margin-bottom: 35px;
				}

				.gjfwDdianLeftThree {
					font-size: 18px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #4C4C4C;
					margin-bottom: 23px;
				}

				.gjfwDdianLeftFour {
					font-size: 18px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #4C4C4C;
				}
			}

			.gjfwDdianRight {
				margin-left: 30px;

				img {
					width: 400px;
					height: 305px;
				}
			}
		}
	}
	
	@media screen and (max-width:1200px) {
		.sqzxOne {
			width: 100% !important;
			// background: red !important;
			display: block !important;
			height: auto !important;
	
			.sqzxOneForBottom {
				border-bottom: 2px solid #eeeeee;
			}
	
			.sqzxOneFor {
				width: 100% !important;
				padding-bottom: 10px !important;
				box-sizing: border-box;
	
				.sqzxOneForName {
					// margin-top: 10px !important;
					font-size: 20px !important;
				}
	
				.sqzxOneForCen {
					font-size: 18px !important;
				}
	
				.sqzxOneForXian {
					display: none;
				}
			}
		}
	
		.fwys {
			width: 100% !important;
			// background: greenyellow !important;
			display: block !important;
			margin-top: 10px !important;
	
			.fwysTil {
				font-size: 28px !important;
				padding-left: 30px !important;
				box-sizing: border-box !important;
				margin-bottom: 15px !important;
			}
	
			.fwysBox {
				display: block !important;
				padding: 0 30px !important;
				box-sizing: border-box !important;
				margin-bottom: 0 !important;
			}
	
			.fwysBoxFor {
				width: 100% !important;
				margin: 0 !important;
				padding: 15px !important;
				box-sizing: border-box !important;
				margin-bottom: 10px !important;
	
				.fwysBoxForImg {
					width: 100% !important;
					height: auto !important;
	
					img {
						width: 100% !important;
						height: auto !important;
					}
				}
	
				.fwysBoxForName {
					margin: 10px 0 !important;
					padding: 0 !important;
					font-size: 26px !important;
				}
	
				.fwysBoxForCen {
					margin: 0 !important;
				}
			}
		}
	
		.cjfk {
			width: 100% !important;
			// background: paleturquoise !important;
			margin-top: 10px !important;
	
			.cjfkTil {
				font-size: 28px !important;
				padding-left: 30px !important;
				box-sizing: border-box !important;
				margin-bottom: 15px !important;
			}
	
			.cjfkBox {
				display: block !important;
				padding: 0 30px !important;
				box-sizing: border-box !important;
	
				.cjfkBoxFor {
					width: 100% !important;
					margin: 0 !important;
					margin-bottom: 10px !important;
				}
			}
		}
	
		.gjfw {
			width: 100% !important;
			// background-color: green;
			margin-top: 10px !important;
			height: auto !important;
			padding: 0 30px !important;
			box-sizing: border-box !important;
	
			.gjfwTil {
				font-size: 28px !important;
				margin-bottom: 10px !important;
			}
	
			.gjfwXl {
				width: 100% !important;
				margin-bottom: 0 !important;
	
				.gjfwXlName {
					font-size: 20px !important;
				}
	
				.gjfwXlJt {
					img {
						width: 20px !important;
						height: 10px !important;
					}
				}
			}
		}
		.gjfwDdian {
			width: 100% !important;
			// background-color: pink !important;
			padding: 0 !important;
			height: auto !important; 
			display: block !important; 
			margin-top: 10px !important;
			.gjfwDdianLeft{
				height: auto !important;
				width: 100% !important;
				padding: 0 30px !important;
				box-sizing: border-box !important; 
				.gjfwDdianLeftOne{
					height: auto !important; 
					font-size: 25px !important;
					margin-bottom: 10px !important;
				}
				.gjfwDdianLeftTwo{
					font-size: 20px !important;
					margin-bottom: 10px !important;
				}
				.gjfwDdianLeftThree{
					font-size: 14px !important;
					margin-bottom: 10px !important;
				}
				.gjfwDdianLeftFour{
					font-size: 14px !important;
				}
			}
		
			.gjfwDdianRight {
				width: 100%;
				margin: 0 !important;
				margin-top: 10px !important;
				padding: 0 30px !important;
				box-sizing: border-box !important; 
				img {
					width: 100% !important;
					height: auto !important;
				}
			}
		}
	}
</style>